import {BaseAreaView, OBaseAreaViewInit} from "lib/commons/views";
import {IDepotResUiEnv, IDepotUiEnv} from "lib/store/depot";
import {IReg, IRegPointer, REG} from "lib/commons/registry";
import {DOMSH} from "lib/commons/xml/domsh";
import {DOM, JSX} from "lib/commons/xml/dom";
import {JNodeInfos, URLTREE} from "lib/store/urlTree";
import {BASIS} from "back/commons/basis";
import {InfoFocusRes} from "lib/store/res";


export interface ResAncView extends BaseAreaView<IRegPointer<IDepotResUiEnv>> {
	initialize(init: OResAncViewInit): this
}

export interface OResAncViewInit extends OBaseAreaViewInit<IRegPointer<IDepotResUiEnv>> {
	//listenAncChanges?: boolean
}

export class ResAncView extends BaseAreaView<IRegPointer<IDepotResUiEnv>> {
	reg: IReg<IDepotResUiEnv & IDepotUiEnv>;

	protected _initialize(init: OResAncViewInit) {
		this.reg = init.areaContext.reg || this.findReg(init);
		super._initialize(init); //init this.area, this.areaContext
		this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);
		//if (init.listenAncChanges)
		this.reg.env.nodeInfosChange?.on("urlAncChange", (this._ancLstn = () => {this.refresh()}));
	}

	protected _ancLstn: (niNew: JNodeInfos, ancOld: JNodeInfos[]) => void;

	protected _refresh() {
		const env = this.reg.env;
		if (env.nodeInfos) {
			BASIS.clearContent(this.shadowRoot);
			this.draw();
		} else if (env.nodeInfosPending) {
			env.nodeInfosPending.then(this.refresh.bind(this));
		} else {
			//Pas de nodeInfos, ni de chargement en cours => erreur
			BASIS.clearContent(this.shadowRoot);
		}
	}

	protected draw() {
		let nodes = this.reg.env.nodeInfos.urlAnc;
		DOM.setHidden(this, nodes == null);
		if (nodes == null) return; //La config de l'urlTree renderer ne retourne pas les ancêtres dans le nodeInfo.
		const sr = this.shadowRoot;
		let nodePath = null;
		for (let node of nodes) {
			nodePath = URLTREE.appendLeafToPath(nodePath, node);
			const nodeType = this.reg.env.resTypes.getResTypeFor(node);
			//todo: version ?
			let version: HTMLElement;
			if (nodeType.prcVersionning === "VCB") {
				version = <span class="version">{nodeType.resVersion(node)}</span>;
			}
			sr.appendChild(<span class="sep"><c-button class="anc" onclick={this.onClickEntry} data-path={nodePath}>
				<img class="icon" src={nodeType.resIcon(node)}/>
				<span class="name">{nodeType.resName(node)}</span>
				{version}
			</c-button></span>);
		}
	}

	onClickEntry(this: HTMLButtonElement, ev: MouseEvent) {
		const me = DOMSH.findHost<ResAncView>(this);
		const infoBroker = me.reg.env.infoBroker;
		if (infoBroker) infoBroker.dispatchInfo(new InfoFocusRes(this.getAttribute('data-path')), me);
	}

	onViewHidden(closed?: boolean) {
		if (closed && this._ancLstn) {
			this.reg.env.nodeInfosChange?.removeListener("urlAncChange", this._ancLstn);
		}
	}
}

REG.reg.registerSkin('store-res-anc', 1, /* language=CSS */ `
	:host {
		display: flex;
	  flex-flow: wrap;
  }

  .sep {
	  display: flex;
  }

  .sep::after {
	  content: "❯";
	  display: flex;
	  align-items: center;
	  color: var(--alt1-color);
  }

  .sep:lang(ar)::after {
	  content: "❮";
  }

  .name {
	  margin-inline-start: .2em;
	  word-break: normal;
  }

  .version {
	  color: var(--alt1-color);
  }

  .version::before {
	  content: '@';
  }

  .icon {
	  filter: var(--filter);
	  height: var(--icon-size);
  }
`);

customElements.define('store-res-anc', ResAncView);